import React from 'react'
import SliderHighlight from '../SliderHighlight/index'


const CustomHighlightSelections = ({
    currentActiveSelection, 
    attributeStyling, 
    setIdForActiveSelection, 
    movies, 
    moviesRoutesData, 
    elbenwald,
    selectionId, 
    itemSelection, 
    itemCollections, 
    highlights, 
    informationStyling,
    highlightAppearance,
    features,
    detailsStyling,
    hiddenAttributes,
    ignoreAttributesForPerformanceFilter,
    translation,
    theme,
    isConnectedFast
}) => {
    if(!itemSelection) {
        return ''
    }

    const { title, filterType, filterValue } = itemSelection
    const backgroundVisualsSettings = {
        style: itemSelection.style,
        trailerAutoplay: itemSelection.trailerAutoplay
    }
    const collectionId = itemSelection.collections[0]
    const collectionItems = itemCollections[collectionId] && itemCollections[collectionId].items ? itemCollections[collectionId].items : []

    return collectionItems.length !== 0 && <SliderHighlight
        attributeStyling={attributeStyling}
        highlightAppearance={highlightAppearance}
        detailsStyling={detailsStyling}
        title={title}
        hiddenAttributes={hiddenAttributes}
        theme={theme}
        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
        filterValue={filterValue}
        filterType={filterType}
        backgroundVisualsSettings={backgroundVisualsSettings}
        items={collectionItems}
        highlights={highlights}
        elbenwald={elbenwald}
        informationStyling={informationStyling}
        currentActiveSelection={currentActiveSelection}
        setIdForActiveSelection={setIdForActiveSelection}
        selectionId={selectionId}
        moviesData={movies}
        moviesRoutesData={moviesRoutesData}
        features={features}
        translation={translation}
        isFront={true}
        scrollToPosition={'slider-highlights slider-selection-highlights ' + selectionId}
        isConnectedFast={isConnectedFast}
    />
}


export default CustomHighlightSelections